// extracted by mini-css-extract-plugin
export default {"leftButton":"_3Jsd4"};